import { Icons } from 'assets/icons/icons.index';
import { Loader, TagLabel } from 'components/atoms';
import { ButtonClose } from 'components/atoms/Button-close/Button-close';
import { Button } from 'components/atoms/Button/Button';
import { PopupOverlay } from 'components/atoms/Popup-overlay/Popup-overlay';
import { FormCoupon } from 'components/organisms/Form-cupon/Form-cupon';
import { ICouponInformation } from 'components/organisms/Form-cupon/models/Form-cupon.interface';
import { PeriodicityOptions } from 'models/periodicity.interface';
import { PeriodicityTypesOptions } from 'pages/Checkout/models/Payment-subscription.interface';
import { IUserSubscription } from 'pages/Edit-Property/models/Edit-Property.interface';
import { InfoChangePlanAddOns } from 'pages/Settings/pages/Payments-billing/models/Payments.interface';
import { useRef, useState } from 'react';
import { formatPrice } from 'utils/payments.utils';
import { getDiffAddon } from 'utils/pricing.utils';
import './Popup-add-on.scss';

interface IPropsPopupAddOn {
  addOn: string[];
  closePopUp: () => void;
  planAddOn?: IUserSubscription[];
  process: () => Promise<void>;
  infoAddOns: InfoChangePlanAddOns;
  setInfoAddOns: (newValues: InfoChangePlanAddOns) => void;
  branch: string;
  coupon: ICouponInformation | undefined;
  setCoupon: (value: ICouponInformation | undefined) => void;
}
export const PopupAddOn = ({
  addOn,
  closePopUp,
  infoAddOns,
  setInfoAddOns,
  planAddOn,
  process,
  branch,
  coupon,
  setCoupon,
}: IPropsPopupAddOn) => {
  const [isLoading, setIsLoading] = useState(false);
  const formCouponRef =
    useRef<{
      validateCoupon: (
        planIds: number[],
        coupon: ICouponInformation
      ) => Promise<void>;
    }>(null);

  const getCoupon = (couponInfo: ICouponInformation) => {
    if (couponInfo) {
      const newDeference = getDiffAddon(
        infoAddOns.originalDeference,
        couponInfo
      );
      setInfoAddOns({
        ...infoAddOns,
        newPrice: infoAddOns.price + newDeference,
        deference: newDeference,
      });
      setCoupon(couponInfo);
    }
  };

  const resetCopunInfo = () => {
    setCoupon(undefined);
    setInfoAddOns({
      ...infoAddOns,
      newPrice: infoAddOns.originalNewPrice,
      deference: infoAddOns.originalDeference,
    });
  };

  const addAddOns = async () => {
    try {
      setIsLoading(true);
      if (isLoading) return;
      await process();
    } catch {
      console.log('Error poner alerta roja 🚨');
    } finally {
      setIsLoading(false);
      closePopUp();
    }
  };
  return (
    <>
      <PopupOverlay>
        <div className={`popup__addon__container`}>
          <ButtonClose
            size="medium"
            className="popup__addon__close"
            onClick={closePopUp}
            template="dark"
          />
          <img
            className="popup__addon__icons"
            src={Icons.contactCenter}
            alt="Soporte"
          />
          <div className="popup__addon__body">
            <div className="popup__addon__body__title">
              <h1>¡adicionales!</h1>
              <p>El beneficio adicional disponible es: </p>
            </div>
            <div className="popup__addon__body__content">
              {planAddOn?.length ? (
                <>
                  <div className="popup__addon__body__content__tags">
                    {addOn.map((benefic, index) => (
                      <TagLabel key={index} typeStyle="rounded" type="primary">
                        {benefic}
                      </TagLabel>
                    ))}
                  </div>
                  {infoAddOns && (
                    <div className="popup__addon__body__content__info">
                      <div className="popup__addon__mb-8">
                        <span className="orange bold">{` Tu plan anual pasará de $${formatPrice(
                          infoAddOns.price,
                          branch
                        )} a $${formatPrice(
                          infoAddOns.newPrice,
                          branch
                        )}.`}</span>
                        <span>
                          {' '}
                          {` Para que el cambio sea efectivo debe pagar`}
                        </span>
                        <span className="bold">{` pagar una diferencia de $${formatPrice(
                          infoAddOns.deference,
                          branch
                        )}.`}</span>
                      </div>
                      <FormCoupon
                        ref={formCouponRef}
                        orderId={'1'}
                        coupon={coupon}
                        value={coupon?.coupon_code}
                        onResetCuponInfo={resetCopunInfo}
                        onGetCoupon={getCoupon}
                        periodicity={
                          PeriodicityOptions.ANUAL as PeriodicityTypesOptions
                        }
                        branch={branch}
                        marginSmall={true}
                        planIds={[Number(planAddOn[0].id)]}
                        templete={'default'}
                      ></FormCoupon>
                    </div>
                  )}
                </>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="popup__addon__actions">
            <Button
              color="primary"
              size="medium"
              template="secondary"
              typeStyle="square"
              className="popup__addon__button"
              type="button"
              isDisabled={false}
              onClick={closePopUp}
            >
              salir
            </Button>
            <Button
              color="primary"
              size="medium"
              template="primary"
              typeStyle="square"
              className="popup__addon__button"
              type="button"
              isDisabled={!planAddOn?.length}
              onClick={addAddOns}
            >
              Realizar pago
            </Button>
          </div>
        </div>
      </PopupOverlay>
      {isLoading && <Loader />}
    </>
  );
};
